export default __webpack_public_path__ + "static/char-s-18-cht-df8e2c3d98bc447ca0909495db28e116.png";